(function() {
    var ui = fpUtil.getNamespace('ui', fp);

    ui.ProductActions = fp.Component.extend({
        construct: function (element, config, template, parent) {
            this._super(element, config, template, parent);

            _.defaults(this.config, {
                listManager: fp.listManager,
                disableInList: false,
                stopPropagation: true,
                onRefreshUI: $.noop
            });

            var self = this,
                refreshUIProxy = function(event, payload) {
                    self.refreshUI(event, payload);
                };

            this.events = [{
                name: fp.events.LIST_ITEM_BEFORE_CHANGE,
                value: refreshUIProxy
            }, {
                name: fp.events.LIST_ITEM_CHANGED,
                value: refreshUIProxy
            }];

            if(this.config.disableIncrementer) {
                this.events.push({
                    name: fp.events.PRODUCT_ACTION_OPEN,
                    value: $.proxy(this.__closeActionActive, this)
                });
            }

            this.init();
        },
        init: function(autoRender) {
            if(!this.initialized) {
                this.$element.data('fp.ui.Component', this);
            }
            this.initialized = true;

            if(fpUtil.getBoolean(autoRender, true)) this.render();
        },
        render: function(params) {
            this.destroyChildComponents();

            this.rendered = true;

            const $element = this.$element.attr('data-fp-component', 'true'),
                $list = $element.closest('.fp-list,.fp-mini-list');
            this.inList = $list.length > 0;
            this.inFullList = this.inList && !$list.hasClass('fp-mini-list');

            if(fpUtil.isNull(this.config.showLoading)) {
                this.config.showLoading = $element.find('.fp-btn-add').length > 0;
            }
            if(this.config.showLoading) {
                $element.append('<div class="fp-overlay"></div>' + fp.ui.renderTemplate('component/0/animated-loading.html'));
            }

            this.showVarietyTotal = !_.contains(['item-action-variety', 'item-action-list-item', 'item-action-search'], $element.attr('data-role'));

            this.bindEvents();

            // fp.log($element, $element.attr('data-list-item-id'), this.config)
            const listItem = this.getListItem(),
                product = fpUtil.getProduct(this.config.item),
                productId = S.getString($element.attr('data-product-id'), product.id);

            if(listItem) {
                this.refreshUI({type: fp.events.LIST_ITEM_CHANGED}, {listManager: this.config.listManager, item:listItem});
            }

            if(productId && ui.ProductActions.__focusedItem?.productId === productId) {
                this.$element.find('.' + ui.ProductActions.__focusedItem.className).trigger('focus');
                delete ui.ProductActions.__focusedItem;
            }
        },
        refreshUI: function(event, payload) {
            if(!payload) return;
            if (payload.listManager.getList().id !== this.config.listManager.getList().id) return;

            var config = this.config,
                $element = this.$element,
                $parent = $element.closest('.fp-item'),
                item = payload.item;

            //if($element.closest('.fp-product-list-lg').length) {
            //     fp.log(this.id, '============');
            //     fp.log('hasListItem' ,hasListItem);
            //     fp.log('hasProduct' ,hasProduct);
            //     fp.log('config.disableInList', config.disableInList );
            //     fp.log('this.showVarietyTotal', this.showVarietyTotal);
            //     fp.log('productId', productId, item.product_id);
            //     fp.log('listItemId', listItemId, item.id);
            //     fp.log('oldListItemId', oldListItemId, listItemId);
            //     fp.log('============');
            //}

            if(this.showVarietyTotal || config.disableInList) {
                var product = fpUtil.getProduct(config.item),
                    productId = S.getString($element.attr('data-product-id'), product.id),
                    hasProduct = productId && productId == item.product_id;

                if(!hasProduct) return;
            }
            else {
                var oldListItemId = payload.oldListItemId,
                    listItemId = config.disableInList || this.showVarietyTotal ? null : $element.attr('data-list-item-id'),
                    hasListItem = (listItemId && listItemId == item.id) || (oldListItemId && oldListItemId == listItemId);

                if(!hasListItem) return;
            }

            var eventNs = fpUtil.getEventNs(event),
                changeType = fpConstants.listItemChangeType;

            // if(this.id == 'fp-pa-17') {
            //     fp.log('eventNs', eventNs);
            //     fp.log('payload.itemChangeType', payload);
            // }

            const enableQtyDropDown = fpConfig.enableQtyDropDown && config.enableQtyDropDown !== false,
                $activeElement = $(document.activeElement),
                $btnDecrement = $element.find('.fp-btn-decrement'),
                $btnIncrement = $element.find('.fp-btn-increment');

            switch(eventNs) {
                case fp.events.LIST_ITEM_BEFORE_CHANGE:
                    switch (payload.itemChangeType) {
                        case changeType.ADD:
                        case changeType.REMOVE:
                        case changeType.INCREMENT:
                        case changeType.UPDATE_VARIETY:
                            this.showLoading();
                            // if(!config.disableInList) this.showLoading();
                            break;
                        default:
                            break;
                    }
                    return;
                default:
                    break;
            }

            item = payload.item || this.getListItem();
            var addToListLabel = config.addToListLabel != null ? config.addToListLabel : fp.config.addToListLabel;

            if(!config.disableInList) {
                var quantity;

                 if(this.showVarietyTotal && $element.attr('data-role') !== 'item-full-list') {
                    quantity = fp.ui.ListManager.getItemQuantityTotal({
                        item: item,
                        ignoreNotAvailable: true,
                        forQuantityIndicator: false,
                        ignoreCrossed: this.inFullList,
                        listManager: config.listManager
                    });
                    
                }
                else {
                    quantity = fp.ui.ListManager.getItemQuantity(item, true, false, this.inFullList);
                }
                
                if (quantity) {
                    addToListLabel = fpUtil.getItemButtonHtml(item, quantity);
                    $element.addClass('fp-is-item-in-list');

                    $element.toggleClass('fp-has-item-quantity-label', S(addToListLabel).contains('fp-item-quantity-label'));
                    $element.find('.fp-dropdown-value').attr('title', quantity + ' in cart');
                    $element.find('.fp-value').attr('aria-label', quantity + ' items');

                    $parent.addClass('fp-is-item-in-list');

                    var quantityProperty = 'quantity_label';
                    if (quantity === 1) quantityProperty += '_singular';

                    var quantityLabel = S.getString(this.getProduct(item)[quantityProperty]),
                    quantityLabel = quantityLabel ? ' ' + quantityLabel : '',
                    quantityAriaLabel = quantity + quantityLabel + ', ' + item.product.name + ' in cart';

                    $parent.find('.fp-item-quantity').text(quantity).attr('aria-label', quantityAriaLabel);
                    $element.find('.fp-btn-increment').attr('aria-label', fp.ui.locale('aria-add-to-list', 'Increase item quantity by 1: ') + item.product.name);
                }
                else {
                    $element.removeClass('fp-is-item-in-list fp-has-item-quantity-label');
                    $parent.removeClass('fp-is-item-in-list');
                    $element.find('.fp-btn-increment').attr('aria-label', fp.ui.locale('aria-add-to-list', fp.config.addToListLabel + ': ') + item.product.name);
                }
                if (this.inList) addToListLabel = fpUtil.getItemButtonHtml(item, quantity);
            }

            if(
                enableQtyDropDown &&
                item.product &&
                !(!config.disableInList && _.size(item.varieties) && this.showVarietyTotal && config.stopPropagation)
            ) {
                if(!quantity) quantity = item.product.quantity_step || 1;

                var self = this,
                    dropdownQtyOptions = {
                        autoInit: true,
                        ariaLabel: fp.ui.locale('aria-label-dropdown-quantity', 'Select quantity'),
                        onChange: function(value) {
                            self.onQtyChanged(value, $(this).closest('.fp-dropdown-qty-wrap'), item);
                        }
                    },
                    $qtyDropdown = $element.find('.fp-dropdown-qty');

                //if(config.disableIncrementer) {
                //    dropdownQtyOptions.onClose = function () {
                //        self.__closeActionActive();
                //    };
                //}

                if($element.closest('.fp-product-carousel, .fp-scroll-list-x').length) {
                    dropdownQtyOptions.container = 'dropdown-container';
                }
                if(fpConfig.enableMobile) {
                    $parent.addClass('fp-is-qty-ddl');
                    dropdownQtyOptions.containerClass = 'fp-dropdown-qty-wrap';
                }

                if(!$qtyDropdown.length) {
                    $qtyDropdown = $(fpUi.renderTemplate('component/0/dropdown-qty.html', {
                        item: item,
                        quantity: quantity
                    }, null, true)).find('.fp-dropdown-qty');

                    if(fpConfig.enableMobile) {
                        $qtyDropdown.parent().insertAfter($element.find('.fp-btn-add'));
                    }
                    else {
                        $element.append($qtyDropdown.parent());
                    }

                    $qtyDropdown.dropdown(dropdownQtyOptions, null, self);
                    $element.toggleClass('fp-has-product-label', !!$element.find('.fp-product-label').html());
                }
                else {
                    $qtyDropdown.dropdown(dropdownQtyOptions, null, self);
                    var quantityDropdown = $qtyDropdown.data('fp.ui.Component');
                    if(quantityDropdown) quantityDropdown.setValue(quantity);

                    this.toggleQuantityInputDropdown(event, item.product, quantity);
                }
            }
            else {
                $parent.removeClass('fp-is-qty-ddl');
                $element.find('.fp-btn-add').html(addToListLabel);
            }

            switch(eventNs) {
                case fp.events.LIST_ITEM_CHANGED:
                    if(payload.itemChangeSuccess) {
                        switch (payload.itemChangeType) {
                            case changeType.ADD:
                                if (config.item) config.item = item;
                                if(!config.disableInList && !this.showVarietyTotal) $element.attr('data-list-item-id', item.id);
                                if(!enableQtyDropDown) {
                                    ui.ProductActions.__focusedItem = {
                                        productId: item.product?.id,
                                        className: 'fp-btn-increment'
                                    };
                                }
                                //ui.ProductActions.showPopover(item);
                                break;
                            case changeType.REMOVE:
                                $element.removeAttr('data-list-item-id');
                                if(!enableQtyDropDown) {
                                    ui.ProductActions.__focusedItem = {
                                        productId: item.product?.id,
                                        className: 'fp-btn-increment'
                                    };

                                    if($activeElement.hasClass('fp-btn-decrement')) {
                                        $btnIncrement.trigger('focus');
                                    }
                                }
                                break;
                            case changeType.INCREMENT:
                                $element.find('[name="qty-txt"]').val(item.quantity);
                                if(!enableQtyDropDown) {
                                    ui.ProductActions.__focusedItem = {
                                        productId: item.product?.id,
                                        className: $activeElement.hasClass('fp-btn-decrement') ? 'fp-btn-decrement' : 'fp-btn-increment'
                                    };
                                }
                                break;
                            default:
                                break;
                        }
                    }
                    break;
                default:
                    break;
            }

            this.hideLoading();

            config.onRefreshUI(event, payload);
        },
        onQtyChanged: function(value, $parent, item) {
            var self = this,
                product = item.product,
                $form = this.$element.closest('form'),
                quantity = fpUtil.getFloat(value);

            if(!product) {
                var listItem = this.getListItem();
                product = this.getProduct(listItem);
            }

            if(S(value).endsWith('+')) {
                self.toggleQuantityInputDropdown(null, product, quantity);
                $parent.find('[name="qty-txt"]')
                    .val(quantity)
                    .trigger('focus');
            }
            else {
                if(!quantity) {
                    $parent.find('[name="qty-txt"]').addClass('fp-hidden');
                    if(this.config.disableIncrementer) this.__closeActionActive();
                }

                fp.trigger(fp.events.LIST_ITEM_INCREMENT, {
                    listManager: this.config.listManager,
                    item: item,
                    quantity: quantity,
                    listName: this.config.listName,
                    listPosition: this.config.listPosition,
                    errorSelector: ($form.length ? $form : fpUi.getActiveModal()).find('[data-role="notification"], .fp-notification'),
                    parentModule: self.$element.closest('.fp-module').data('fp.ui.Component')
                });
            }
        },
        onQtyInputChanged: function(event, product) {
            var $target = $(event.target),
                quantity = fpUtil.getFloat($target.val()),
                listItem = this.getListItem();

            if(!product) product = this.getProduct(listItem);

            if(!quantity) {
                $target.val($target.parent().find('[name="fp-dropdown-qty"]').attr('data-quantity-step'));

                if(this.config.disableIncrementer) this.__closeActionActive();
            }

            this.toggleQuantityInputDropdown(event, product, quantity);

            if(listItem && quantity != listItem.quantity) {
                var $form = $target.closest('form');
                fp.trigger(fp.events.LIST_ITEM_INCREMENT, {
                    listManager: this.config.listManager,
                    item: listItem,
                    quantity: quantity,
                    listName: this.config.listName,
                    listPosition: this.config.listPosition,
                    errorSelector: ($form.length ? $form : fpUi.getActiveModal()).find('[data-role="notification"], .fp-notification'),
                    parentModule: this.$element.closest('.fp-module').data('fp.ui.Component')
                });
            }
        },
        toggleQuantityInputDropdown: function(event, product, quantity) {
            var self = this,
                $element = self.$element,
                $parent = $element.find('.fp-dropdown-qty-wrap'),
                $qtyInputWrapper = $parent.find('.fp-qty-txt-wrapper'),
                $qtyInput = $parent.find('input[name="qty-txt"]'),
                $qtyDropdown = $parent.find('.fp-dropdown'),
                qtyDropdown = $qtyDropdown.data('fp.ui.Component'),
                productLabel = fpUtil.getItemQuantityLabel(self.getListItem(), quantity, true),
                maxValue;
                
            if(qtyDropdown) {
                maxValue = fpUtil.getFloat(qtyDropdown.$list.filter('[data-value$="+"]').last().attr('data-value'));
            }

            if(!productLabel) {
                var product;
                productLabel = fpConfig.enableMobile ? ((product = this.getProduct()) && product.size): fpConfig.inListLabel;
            }

            $parent.find('.fp-product-label').html(productLabel);

            $element.toggleClass('fp-has-product-label', !!productLabel);

            if(!$qtyInputWrapper.length) $qtyInputWrapper = $qtyInput;

            if(maxValue && quantity >= maxValue) {
                $qtyInputWrapper.removeClass('fp-hidden');
                $qtyDropdown.addClass('fp-dropdown-qty-input fp-hidden');
            }
            else {
                $qtyDropdown.removeClass('fp-dropdown-qty-input fp-hidden');
                $qtyInputWrapper.addClass('fp-hidden');

                var quantityDropdown = $qtyDropdown.data('fp.ui.Component');
                if(quantityDropdown) quantityDropdown.setValue(quantity);
            }

            $qtyDropdown.add($qtyInputWrapper)
                .css('visibility', 'hidden')
                .delay(100).css('visibility', '');
        },
        getListItem: function (varieties, isSave) {
            var listManager = this.config.listManager,
                listItemId = (this.config.disableInList || this.showVarietyTotal) && !isSave ? null : this.$element.attr('data-list-item-id'),
                listItem;

            if(listItemId) listItem = listManager.getItem(listItemId);
            else {
                var product = fpUtil.getProduct(this.config.item),
                    fieldValue = product.id,
                    options = {
                        isProductId: true,
                        varieties: varieties
                    };

                if(!fieldValue) fieldValue = this.$element.attr('data-product-id');

                if(!fieldValue) {
                    fieldValue = this.$element.attr('data-note');
                    if(fieldValue) {
                        delete options.isProductId;
                        options.isGenericName = true;
                    }
                }

                listItem = listManager.getItem(fieldValue, options);
            }

            return listItem;
        },
        getProduct: function (listItem) {
            var product = fpUtil.getProduct(this.config.item);
            if (!product.id) {
                if(!listItem) listItem = _.getObject(this.getListItem());
                if(listItem.product) product = listItem.product;
            }

            return product.id ? product : null;
        },
        showLoading: function () {
            if(this.config.showLoading) {
                clearTimeout(this.__loadingTimeout);
                this.$element.addClass('fp-animated-loading-container fp-animated-loading-container-no-loading');

                const self = this;
                this.__loadingTimeout = _.delay(function() {
                    self.$element.removeClass('fp-animated-loading-container-no-loading');
                }, fpConstants.progress.DELAY);
            }
        },
        hideLoading: function () {
            clearTimeout(this.__loadingTimeout);
            this.$element.removeClass('fp-animated-loading-container fp-animated-loading-container-no-loading');
        },
        destroy: function(persistUI) {
            this._super(persistUI);

            if(fpConfig.enableMobile) this.$element.prev('[data-action="remove-item"]').off('click.productAction.fp');
            if(persistUI && this.config.disableIncrementer) {
                this.$element.closest('.fp-item').removeClass('fp-is-item-action-active');
            }

            this.unbindEvents();
        },
        bindEvents: function() {
            var onClickProxy = $.proxy(this.onClick, this),
                //self = this,
                $element = this.$element,
                $removeItem;

            $element
                .off('productAction.fp')
                .on('click.productAction.fp keypress.productAction.fp', onClickProxy)
                .on('wheel.productAction.fp', 'input.fp-input-qty-txt', function (event) {
                    $(this).trigger('blur');
                })
                .on('keypress.productAction.fp', 'input.fp-input-qty-txt', function (event) {
                    if (event.keyCode === fpConstants.keycode.RETURN) {
                        event.preventDefault();
                        $(this).trigger('blur');
                    }
                })
                .on('blur.productAction.fp', 'input.fp-input-qty-txt', $.proxy(this.onQtyInputChanged, this));

            if(fpConfig.enableMobile && ($removeItem = $element.prev('[data-action="remove-item"]')).length) {
                $removeItem
                    .off('click.productAction.fp')
                    .on('click.productAction.fp', onClickProxy);
            }

            if(this.config.disableIncrementer) {
                //$element
                //    .on('mousedown.productAction.fp', function() {
                //        self.__overlayFocused = true;
                //        $(this).one('mouseup.productAction.fp', function() {
                //            delete self.__overlayFocused;
                //        });
                //    });

                $element.closest('.fp-item')
                    .find('[data-action="show-item-detail"]')
                    .on('click.productAction.fp', onClickProxy);

                $(document)
                    .off('productAction.fp')
                    .on('click.productAction.fp', $.proxy(this.__closeActionActive, this));
            }

            _.each(this.events, function(item) {
                fp.on(item.name, item.value);
            });
        },
        unbindEvents: function() {
            var $element = this.$element.off('productAction.fp');

            if(fpConfig.enableMobile) {
                $element.prev('[data-action="remove-item"]').off('click.productAction.fp');
            }

            if(this.config.disableIncrementer) {
                $element.closest('.fp-item')
                    .find('[data-action="show-item-detail"]')
                    .off('productAction.fp');
            }

            _.each(this.events, function(item) {
                fp.off(item.name, item.value);
            });
        },
        onClick: function(event) {
            event.preventDefault();

            var config = this.config;
            if(config.stopPropagation || config.disableIncrementer) {
                event.stopImmediatePropagation();
            }

            var $target = $(event.target);
            if(
                ($target.hasClass('fp-animated-loading-container') || (!config.disableIncrementer && $target.hasClass('fp-item-action'))) &&
                !(fpConfig.enableMobile && $target.hasClass('fp-item-has-variety'))
            ) {
                return;
            }

            var self = this,
                $element = this.$element,
                item = {},
                listManager = config.listManager,
                $form = $target.closest('form'),
                productId = S.getString($element.attr('data-product-id')),
                formValues,
                listItem,
                promise;

            if(config.disableIncrementer && productId) {
                //options = {
                //    disableRedirectToDetail: true,
                //    showProductModal: false
                //};

                if($target.closest('.fp-dropdown-qty-wrap').length) return;

                var product = this.getProduct(),
                    disableContinue;

                if(this.showProductDetailModal(product)) {
                    disableContinue = true;
                }
                else if($target.closest('[data-action="show-item-detail"]').length && product) {
                    var $productModal = fp.ui.showModal({
                            name: 'productQuickViewModal',
                            template: 'component/0/modal.html',
                            className: 'fp-product-quick-view-modal',
                            title: 'Product Quick View',
                            content: fp.ui.renderTemplate('component/0/product-list.html', {
                                items: [product],
                                imageUrl: fpUtil.getImageSrc(product, 'medium'),
                                itemListClass: 'fp-item-list-single'
                            })
                        })
                        .on('show.bs.modal', function () {
                            var $productAction = $productModal.find(fpUtil.formatString('.fp-item-action[data-product-id="{0}"]', product.id)),
                                productAction = $productAction.data('fp.ui.Component');
                            if (productAction) productAction.destroy();

                            new fp.ui.ProductActions($productAction, {item: product});
                        });

                    disableContinue = true;
                }
                else {
                    //var $productAction = $this.closest('.fp-item').find('[data-role="item-action"]'),
                    //    productAction = $productAction.data('fp.ui.Component');
                    //if(productAction) productAction.__openActionActive();

                    if(this.isActionActive) {
                        this.__closeActionActive();
                        return;
                    }
                    else if(this.__openActionActive(event)) disableContinue = true;

                    $target = $element.find('.fp-btn-increment');
                }

                var event = $.Event(fp.events.PRODUCT_ACTION_OPEN);
                event.target = $element[0];
                fp.trigger(event);

                if(disableContinue) return;
            }

            if(config.disableInList) {
                if(!item.id) item = fpUtil.getProduct(config.item, item);
                if(_.size(item.varieties)) {
                    $form.find('.fp-notification.fp-error').hide();
                    if(!fpUtil.validateForm($form, null, null, {includeDisplayNone: false})) return;
                    formValues = fp.ui.getFormValues($form, {prefix: ['fp-variety-'], includeDisplayNone: false, ignorePropWarning: true});
                    if(_.size(formValues)) {
                        var otherAttributes = {};
                        _.each(item.varieties, function(variety) {
                            var selectedVariety = formValues[variety.identifier];
                            if(selectedVariety) {
                                var selectedVarietyValues = {};
                                for(var key in formValues) {
                                    key = S(key);
                                    if(key.startsWith(selectedVariety)) {
                                        selectedVarietyValues[key.replace(selectedVariety + '-', '').s] = formValues[key.s];
                                        delete formValues[key.s];
                                    }
                                }

                                if(_.size(selectedVarietyValues)) {
                                    otherAttributes[variety.identifier] = selectedVarietyValues;
                                }
                            }
                        });
                        if(_.size(otherAttributes)) {
                            formValues.other_attributes = otherAttributes;
                        }
                    }
                }
            }
            var isSave = $target.hasClass('fp-btn-save'),

            listItem = this.getListItem(formValues, isSave);

            if(listItem) {
                item = _.getObject(listItem.product, item);

                var isDecrement = $target.hasClass('fp-btn-decrement'),
                    isIncrement = !isDecrement && $target.hasClass('fp-btn-increment'),
                    isRemove = !isDecrement && !isIncrement && $target.hasClass('fp-btn-remove');

                if (isDecrement || isIncrement || isRemove) {
                    if(self.__redirectToShopDetail(item)) return;
                    else if(!isRemove && this.showProductDetailModal(item)) return;

                    var payload = {
                        listManager: listManager,
                        item: listItem,
                        increment: isRemove ? null : (isDecrement ? -1 : 1),
                        listName: config.listName,
                        listPosition: config.listPosition,
                        errorSelector: ($form.length ? $form : fpUi.getActiveModal()).find('[data-role="notification"], .fp-notification'),
                        parentModule: $element.closest('.fp-module').data('fp.ui.Component')
                    }

                    //fixes issue where input is focused/changed and increment/decrement is clicked
                    if(fpConfig.enableQtyDropDown && this.__loadingTimeout) {
                        var $input = this.$element.find('[name="qty-txt"]');
                        if($input.length) {
                            var quantity = fpUtil.getFloat(this.$element.find('[name="qty-txt"]').val());
                            if(quantity != listItem.quantity) payload.quantity = quantity;
                        }
                    }

                    fp.trigger(isRemove ? fp.events.LIST_ITEM_REMOVE : fp.events.LIST_ITEM_INCREMENT, payload);

                    //crossed off items are handled in a special way
                    if (!(listItem.is_crossed && fp.store.allow_shopping_list_crossing)) return;
                }
                else if(!config.disableInList) return;
            }

            if(!item.id) item = fpUtil.getProduct(config.item, item);

            if($element.filter('[data-search-term]').length) {
                fp.trigger(fp.events.PRODUCTS_MODAL_SHOW, {
                    title: S.getString($element.attr('data-search-title'), 'Search Products'),
                    mode: 'search',
                    searchTerm: fpUtil.getStateValue(!item.id, $element.attr('data-search-term')),
                    products: fpUtil.getStateValue(item.id, [item]),
                    listManager: listManager,
                    listName: config.listName
                });

                return;
            }
            if(!item.id && config.item && fpUtil.isNewItem(config.item)) {
                item = config.item;
                formValues = fp.ui.getFormValues($form);
            }
            else {
                var note = S.getString($element.attr('data-note'));
                if(note) {
                    item.id = fpUtil.getNewItemId();
                    item.note = note;
                }
            }

            if(self.__redirectToShopDetail(item)) return;
            else if(this.showProductDetailModal(item)) return;

            var linkedOfferConfig = fpUtil.getObjectFromNamespace('sale_offer.config', item);
            if(!linkedOfferConfig.must_buy && _.size(linkedOfferConfig.linked_offer_ids)) {
                fpService.offerService
                    .get({
                        id: linkedOfferConfig.linked_offer_ids.join()
                    })
                    .done(function(resp) {
                        var productIds = _.unique(_.concat.apply(_, _.pluck(resp.items, 'product_ids')));
                        if(productIds) {
                            fp.trigger(fp.events.PRODUCTS_MODAL_SHOW, {
                                title: S.getString(linkedOfferConfig.text, 'Offers'),
                                productIds: productIds,
                                listManager: listManager,
                                $modal: fp.initProductsModal(false)
                            });
                        }
                    });
            }

            //fp.log('this', self);
            //fp.log('config.item', config.item);

            if(!item.id && productId && config.enableProductApi) {
                this.showLoading();
                promise = fpService.productService.get(productId);
            }

            $.when(promise)
                .done(function(resp) {
                    if(resp) item = resp;
                })
                .always(function() {
                    self.hideLoading();
                    if(!item.id) return;
                    //ui.ProductActions.showPopover(item);

                    // _.each(formValues, function(variety, key) {
                    //     if(!variety) delete formValues[key];
                    // });

                    // var formValues = fp.ui.getFormValues($target.closest('form'));
                    // fp.log('formValues', formValues);

                    if(_.size(self.scope.varietyDefault) && !formValues) formValues = self.scope.varietyDefault;
                    if(fpConfig.enableKiosk && !fpUtil.validateForm($form)) return;

                    fp.trigger(isSave ? fp.events.LIST_ITEM_UPDATE : fp.events.LIST_ITEM_ADD, {
                        listManager: listManager,
                        item: isSave ? listItem : item,
                        formValues: formValues,
                        listName: config.listName,
                        listPosition: config.listPosition,
                        listItemChangeType: isSave ? fpConstants.listItemChangeType.UPDATE_VARIETY : null,
                        errorSelector: ($form.length ? $form : fpUi.getActiveModal()).find('[data-role="notification"], .fp-notification'),
                        parentModule: self.$element.closest('.fp-module').data('fp.ui.Component')
                    });
                });
        },
        showProductDetailModal: function(product) {
            var scope = this.scope;

            scope.varietyDefault = {};

            if(product && _.size(product.varieties)) {
                var isOptional = true,
                    hasDefault = false,
                    hasPrompt = false,
                    isRequired = false,
                    productInList =  _.filter(this.config.listManager.selectedList.items, {product_id: product.id });

                if(_.size(productInList) <= 1) {
                    _.each(product.varieties, function(variety) {
                        scope.varietyType = variety;
                        
                        if(variety.is_prompt) hasPrompt = true;
                        else hasPrompt = false;

                        if(variety.is_required) isRequired = true;
                        else isRequired = false;
                        
                        hasDefault = false;
                        
                        _.each(variety.options, function (varietyOption) {                        
                            if(varietyOption.is_default) {
                                scope.varietyDefault[scope.varietyType.identifier] = varietyOption.value;
                                hasDefault = true;
                            }
                        });
                    });

                    if(!isRequired && !hasPrompt && hasDefault) isOptional = true;
                    else isOptional = false;
                }
                else isOptional = false;

                if(product.id && this.showVarietyTotal && !this.config.disableInList && !isOptional) {
                    fp.trigger(fp.events.PRODUCT_DETAIL_MODAL_SHOW, {
                        listManager: this.config.listManager,
                        productId: product.id,
                        title: product.name,
                        disableExtras: true,
                        item: this.getListItem(),
                        focusElement: this.config.focusElement,
                        alwaysFocus: this.config.alwaysFocus
                    });
                    return true;
                }
            }

            return false;
        },
        // When kiosk is enabled, redirect to detail page instead of directly adding the item to the cart
        // redirect to detail page if it is in shop page, product category page, or product carousel
        __redirectToShopDetail: function(item){
            var $element = this.$element,
                scope = this.scope,
                stateManager = scope.stateManager;

            if(fp.config.enableKiosk && 
                (stateManager.is(stateManager.states["shop"]) || 
                stateManager.is(stateManager.states["product-category"]) ||
                $element.closest(".owl-carousel").length > 0)){
                var deptId = fp.department.id != fp.defaultDepartment.id ? fp.department.id : undefined,
                    detailState =  fpConfig.enableSEO ? stateManager.states["product-detail"] : stateManager.current,
                    productUrl = stateManager.href(detailState, {id: item.id, department_id: deptId}, {canonical_url: item.canonical_url});
 
                stateManager.go(productUrl, null, {absolute: true});
                return true;
            }
            return false
        },
        __openActionActive: function(event) {
            var $element = this.$element,
                $item = $element.closest('.fp-item'),
                item = this.getListItem(),
                quantity = fpUi.ListManager.getItemQuantity(item, true, false, this.inFullList);

            if (quantity) {
                this.isActionActive = true;
                $item.addClass('fp-is-item-action-active');

                var $qtyDropdown = $element.find('.fp-dropdown-qty'),
                    qtyDropdown = $qtyDropdown.data('fp.ui.Component'),
                    maxValue;

                if(qtyDropdown) {
                    maxValue = fpUtil.getFloat(qtyDropdown.$list.filter('[data-value$="+"]').last().attr('data-value'));
                }

                if (maxValue && quantity >= maxValue) {
                    $element
                        .find('.fp-qty-txt-wrapper')
                        .removeClass('fp-hidden')
                        .find('input[name="qty-txt"]')
                        .trigger('focus');
                }
                else {
                    $qtyDropdown.removeClass('fp-hidden');
                    if (qtyDropdown) dropdown.open();
                }

                return true;
            }
        },
        __closeActionActive: function(event) {
            if(this.isActionActive) {
                var $element = this.$element;

                if(!event || (event.target != _.first($element) && !$.contains($element, event.target))) {
                    delete this.isActionActive;
                    $element.closest('.fp-item').removeClass('fp-is-item-action-active');
                    $element.find('.fp-qty-txt-wrapper').addClass('fp-hidden');
                    var dropdown = $element.find('.fp-dropdown').addClass('fp-hidden').data('fp.ui.Component');
                    if (dropdown) dropdown.close(0);
                }
            }
        }
    });
})();